/**
 * Module display names, in one place.
 *
 * The product page and the module page both need them, and a module falling
 * back to its registry key ("content-studio") in front of a client is the kind
 * of small sloppiness that reads as an unfinished product.
 */
export const MODULE_LABELS: Record<string, string> = {
  'website-manager': 'Website Manager',
  'content-studio': 'Content Studio',
  'inbox': 'Inbox',
  'finance': 'Finance',
};

export const moduleLabel = (key: string) => MODULE_LABELS[key] ?? key;

/**
 * May this module be offered for this product?
 *
 * Mirrors `moduleAllowsProduct` on the API. A module bound to particular
 * websites' code carries `slugs` and answers only for those; a tenant-agnostic
 * one carries none and answers for any product.
 *
 * This existed inline as `d.slugs.includes(slug)` and was a live crash: the
 * registry gained a module with no `slugs`, the web type still declared the
 * field required, so it compiled and threw `Cannot read properties of
 * undefined` while rendering the product edit modal. The type is honest now and
 * the rule lives in one place, named, so the next module cannot reintroduce it.
 */
export function moduleAllowsProduct(
  definition: { slugs?: string[]; tenantAgnostic?: boolean }, slug: string,
): boolean {
  if (definition.tenantAgnostic) return true;
  return definition.slugs?.includes(slug) ?? false;
}
